"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorUnlockingWallet = void 0;
class ErrorUnlockingWallet extends Error {
    constructor() {
        super('There was an error unlocking your wallet. Please be sure your wallet is unlocked and try again.');
        this.name = 'ErrorUnlockingWallet';
    }
}
exports.ErrorUnlockingWallet = ErrorUnlockingWallet;
//# sourceMappingURL=types.js.map